import type { EntreeJournal } from '../api/journal';

/**
 * Le tableau du journal, partagé par l'écran Journal et le bloc du tableau de
 * bord : une seule mise en forme, donc aucune dérive entre les deux.
 *
 * L'écran ne fabrique aucun libellé : `actionLibelle` vient du serveur, et la
 * cible est telle qu'il l'a écrite.
 */
export function TableJournal({
  items,
  messageVide,
  legende,
  chargement = false,
}: {
  readonly items: readonly EntreeJournal[];
  readonly messageVide: string;
  readonly legende: string;
  readonly chargement?: boolean;
}) {
  if (items.length === 0) {
    return <p className="p-6 text-sm text-slate-600">{messageVide}</p>;
  }

  return (
    <div
      className="overflow-x-auto transition-opacity"
      aria-busy={chargement}
      style={chargement ? { opacity: 0.5 } : undefined}
    >
      <table className="w-full text-sm text-left">
        <caption className="sr-only">{legende}</caption>
        <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200">
          <tr>
            <th scope="col" className="px-6 py-3 whitespace-nowrap">
              Quand
            </th>
            <th scope="col" className="px-6 py-3">
              Compte
            </th>
            <th scope="col" className="px-6 py-3">
              Action
            </th>
            <th scope="col" className="px-6 py-3">
              Objet
            </th>
            <th scope="col" className="px-6 py-3">
              Détail
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {items.map((entree) => (
            <tr key={entree.id} className="hover:bg-slate-50 transition-colors">
              <td className="px-6 py-3 text-slate-600 mono whitespace-nowrap">
                {entree.quand.slice(0, 16)}
              </td>
              <td className="px-6 py-3 text-slate-600">{entree.email}</td>
              <td className="px-6 py-3 font-medium text-slate-800 whitespace-nowrap">
                {entree.actionLibelle}
              </td>
              <td className="px-6 py-3 text-slate-600 mono">{entree.cible}</td>
              <td className="px-6 py-3 text-slate-500">{entree.details}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
